import TALogo from '../assets/images/talents-logo-sm.png';
import TAFavIcon from '../assets/images/logo-sm.png';

import customFormsLogo from '../assets/images/PSUT-logo-transparent.png';
import customHeaderLogo from '../assets/images/psut-logo.webp';
import psutFavicon from '../assets/images/psut-favicon.png';

const defaultTAColors = {
	PRIMARY_COLOR: '#1cdcab',
	SECONDARY_COLOR: '#1a2229',

	TA_GREEN: '#1cdcab',
	TA_GREEN_LIGHTER: '#4ae8c0',
	TA_TRANSPARENT_GREEN: '#1cdcab26',
	TA_DARK_GREEN: '#008d68',
	TA_WHITE: '#ffffff',
	TA_LIGHT: '#f8f8f8',
	TA_DARK: '#2e3a44',
	NAV_BG: '#1a2229',
	SIDE_SUB_MENU_BG: '#000c17',
	CARDS_BG: '#fff',
	BORDER: '#fff',
	BTN_PRIMARY_BG: '#1cdcab',
	BTN_PRIMARY_TXT: '#ffffff',
	BTN_SECONDARY_BG: '#1cdcab33',
	BTN_SECONDARY_BG_HOVER: '#fff',
	TA_EBONY_CLAY: '#252F38',
	TA_GUNMETAL: '#485460',
	TA_BLUISH_GREY: '#808e9b',
	TA_CLOUDY_BLUE: '#d2dae2',
	TA_ERROR: '#ee4444',
	TA_INFO: '#0090ff',
	TA_WARNING: '#faad14',
	TA_GREEN_BLUE: '#20c79c',
	TA_DISABLED: '#bfbfbf',
	SIGN_IN_BG_GRADIANT_1: '#000000b3',
	SIGN_IN_BG_GRADIANT_2: '#00000080',

	HEADER_LOGO: TALogo,
	FORMS_LOGO: TALogo,
	FAV_ICON: TAFavIcon,
	TAB_TITLE: 'Talents Arena'
};

const psutColors = {
	//remember to change it in craco config as well
	PRIMARY_COLOR: '#01A9E0',
	SECONDARY_COLOR: '#001871',

	//sign in page background gradiant
	SIGN_IN_BG_GRADIANT_1: '#01A9E0',
	SIGN_IN_BG_GRADIANT_2: '#001871',

	//bg for priamry Btns and inputs border
	TA_GREEN: '#01A9E0',

	//bg for primary Btns hover/press
	TA_GREEN_LIGHTER: '#4ae8c0',

	//bg for disabled secondary and primary btns
	TA_TRANSPARENT_GREEN: '#1cdcab26',

	//????
	TA_DARK_GREEN: '#008d68',

	//primary btns text and disabled text on hover,
	// secondary btns bg on hover,
	TA_WHITE: '#ffffff',

	//body bg
	TA_LIGHT: '#f8f8f8',

	//????
	TA_DARK: '#2e3a44',

	//bg Nav bar, bg side bar
	NAV_BG: '#001871',
	SIDE_SUB_MENU_BG: '#041654',

	//perks card bg
	CARDS_BG: '#f2fbfd',

	// perks card border
	BORDER: '#001871',

	BTN_PRIMARY_BG: '#01A9E0',
	BTN_PRIMARY_TXT: '#f9f9f9',

	BTN_SECONDARY_BG: '#ceeff8',
	BTN_SECONDARY_BG_HOVER: '#ceeff8c2',

	//????
	TA_EBONY_CLAY: '#252F38',

	//????
	TA_GUNMETAL: '#485460',

	//????
	TA_BLUISH_GREY: '#808e9b',

	//????
	TA_CLOUDY_BLUE: '#d2dae2',

	//delete btn in profile
	TA_ERROR: '#ee4444',

	//????
	TA_INFO: '#0090ff',

	//????
	TA_WARNING: '#faad14',

	//Add job btn in outsourcing text abd border
	TA_GREEN_BLUE: '#20c79c',

	//primary btn disabled text
	TA_DISABLED: '#bfbfbf',

	HEADER_LOGO: customHeaderLogo,
	FORMS_LOGO: customFormsLogo,
	FAV_ICON: psutFavicon,
	TAB_TITLE: 'PSUT'
};

export const availableThemes = {
	defaultTAColors: {
		value: defaultTAColors,
		title: 'defaultTAColors'
	},
	psutColors: {
		value: psutColors,
		title: 'psutColors'
	}
};
